var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loading
    ? _c(
        "div",
        {
          staticClass: "container p-8",
          staticStyle: { "margin-bottom": "10pc" },
        },
        [
          _c(
            "el-steps",
            {
              staticClass: "step-header",
              attrs: { active: _vm.activeStep, "align-center": "" },
            },
            _vm._l(_vm.steps, function (step) {
              return _c("el-step", {
                key: step.id,
                attrs: { title: step.title, description: step.description },
              })
            }),
            1
          ),
          _c("div", { staticClass: "container" }, [
            _vm.activeStep === 0
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "center" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "SelectOrder Type" },
                        model: {
                          value: _vm.activeOrderType,
                          callback: function ($$v) {
                            _vm.activeOrderType = $$v
                          },
                          expression: "activeOrderType",
                        },
                      },
                      _vm._l(_vm.orderTypes, function (elem) {
                        return _c("el-option", {
                          key: elem,
                          attrs: { label: elem, value: elem },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.activeStep === 1
              ? _c(
                  "div",
                  [
                    _c("h1", [_vm._v(_vm._s(_vm.activeOrderType))]),
                    _c(
                      "div",
                      { staticStyle: { "text-align": "center" } },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function () {
                                return (_vm.modalNewStep = true)
                              },
                            },
                          },
                          [_vm._v(" Add Step ")]
                        ),
                      ],
                      1
                    ),
                    !!_vm.activeAppStepObj
                      ? _c(
                          "el-tabs",
                          {
                            key: _vm.tabVersion,
                            staticClass: "demo-tabs",
                            attrs: { type: "border-card", closable: true },
                            on: { edit: _vm.handleDelete },
                            model: {
                              value: _vm.activeAppStep,
                              callback: function ($$v) {
                                _vm.activeAppStep = $$v
                              },
                              expression: "activeAppStep",
                            },
                          },
                          _vm._l(
                            _vm.appSteps.filter(function (as) {
                              return !as.delete
                            }),
                            function (appStep, index) {
                              return _c(
                                "el-tab-pane",
                                {
                                  key: index,
                                  attrs: {
                                    label: appStep.displayName,
                                    name: appStep.displayName,
                                  },
                                },
                                [
                                  _vm.activeAppStepObj
                                    ? _c("app-step", {
                                        key: index,
                                        attrs: {
                                          "v-model": _vm.activeAppStepObj,
                                          appSteps: _vm.allAppSteps,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            }
                          ),
                          1
                        )
                      : _c("div", { staticStyle: { "text-align": "center" } }, [
                          _c(
                            "p",
                            {
                              staticStyle: {
                                "margin-top": "5pc",
                                padding: "5pc",
                                "font-weight": "bolder",
                                color: "red",
                              },
                            },
                            [_vm._v("No data")]
                          ),
                        ]),
                  ],
                  1
                )
              : _vm._e(),
            _c("div", { attrs: { id: "nav-bar" } }, [
              _c(
                "span",
                {
                  on: {
                    click: function ($event) {
                      _vm.activeStep = 0
                    },
                  },
                },
                [_vm._v(" < Back ")]
              ),
              _c(
                "span",
                [
                  _c("el-button", { on: { click: _vm.saveChanges } }, [
                    _vm._v(" Save Changes "),
                  ]),
                ],
                1
              ),
            ]),
          ]),
          _c(
            "el-dialog",
            {
              attrs: {
                "close-on-click-modal": false,
                visible: _vm.modalNewStep,
                width: "80%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.modalNewStep = $event
                },
                close: _vm.closeModal,
              },
            },
            [
              _vm._v(" New Step name "),
              _c("el-input", {
                attrs: { type: "text" },
                model: {
                  value: _vm.newStepName,
                  callback: function ($$v) {
                    _vm.newStepName = $$v
                  },
                  expression: "newStepName",
                },
              }),
              _c("el-button", { on: { click: _vm.addAppStep } }, [
                _vm._v(" Create "),
              ]),
              _c("el-button", { on: { click: _vm.closeModal } }, [
                _vm._v(' Cancel" '),
              ]),
            ],
            1
          ),
        ],
        1
      )
    : _c("div", [_vm._v(" Loading... ")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }